import { createContext, useCallback, useEffect, useState } from 'react';

export type INewsArticleContext = {
  article: NewsArticleModel | undefined;
  setArticleId: (ig: string) => void;
};

const initialState: INewsArticleContext = {
  article: undefined,
  setArticleId: () => {},
};

export const NewsArticleContext = createContext(initialState);

export function NewsArticleContextProvider({ children }: { children: React.ReactNode }) {
  const [itemGuid, setItemGuid] = useState<string>('');
  const [article, setArticle] = useState<NewsArticleModel>();

  const getNewsArticle = useCallback(() => {
    fetch('/api/sitecore/PageContentAsync/GetNewsArticleModel', {
      method: 'POST',
      body: new URLSearchParams({ id: itemGuid }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result) {
          var article = result as NewsArticleModel;
          if (article) setArticle(article);
        }
      });
  }, [itemGuid]);

  const setArticleId = (ig: string) => {
    if (itemGuid !== ig) {
      setItemGuid(ig);
    }
  };

  useEffect(() => {
    if (itemGuid) getNewsArticle();
  }, [itemGuid, getNewsArticle]);

  let shared: INewsArticleContext = {
    article: article,
    setArticleId: (ig: string) => setArticleId(ig),
  };

  return <NewsArticleContext.Provider value={shared}>{children}</NewsArticleContext.Provider>;
}
